module.exports = __webpack_public_path__ + "static/media/bg.bc702fde.svg";